/* Vogtime : reglages portable pour tout le site (ne fait rien sur ordinateur) */
(function () {
  var MOBILE = 768;

  /* Reduit la taille d'un texte jusqu'a ce qu'il tienne sur UNE ligne */
  /* largeur vraiment disponible : celle du bloc parent (sans ses marges internes), jamais plus que l'ecran */
  function place(el) {
    var ecran = document.documentElement.clientWidth - 32;
    var p = el.parentElement, w = ecran;
    while (p && p !== document.body) {
      var cs = getComputedStyle(p);
      if (cs.display !== 'inline' && cs.display !== 'contents') {
        var pw = p.getBoundingClientRect().width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        if (pw > 40) { w = Math.min(pw, ecran); break; }
      }
      p = p.parentElement;
    }
    var ms = getComputedStyle(el);
    return w - (parseFloat(ms.marginLeft) || 0) - (parseFloat(ms.marginRight) || 0);
  }

  /* largeur reelle du texte (mesuree sur le texte lui-meme, pas sur la boite) */
  function largeurTexte(el) {
    var r = document.createRange();
    r.selectNodeContents(el);
    return r.getBoundingClientRect().width;
  }

  function uneLigne(el, min) {
    if (!el.offsetWidth) return;
    el.querySelectorAll('br').forEach(function (br) { br.replaceWith(document.createTextNode(' ')); });
    el.style.setProperty('white-space', 'nowrap', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('text-overflow', 'ellipsis', 'important');
    el.style.setProperty('max-width', '100%', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
    el.style.removeProperty('font-size');
    el.style.removeProperty('letter-spacing');
    var cs = getComputedStyle(el);
    var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) + (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.borderRightWidth) || 0);
    var dispo = place(el) - pad - 2;
    var s = parseFloat(cs.fontSize) || 16, n = 0;
    var ls = parseFloat(cs.letterSpacing) || 0;
    function trop() { return largeurTexte(el) > dispo; }
    /* d'abord on resserre l'espacement des lettres s'il est large */
    if (trop() && ls > s * 0.08) el.style.setProperty('letter-spacing', '0.08em', 'important');
    while (trop() && s > (min || 11) && n < 80) {
      s -= 0.5; n++;
      el.style.setProperty('font-size', s + 'px', 'important');
    }
    /* trop long meme en petit : on ne coupe JAMAIS le texte, il revient a la ligne normalement */
    if (trop()) {
      ['white-space', 'overflow', 'text-overflow', 'font-size', 'letter-spacing'].forEach(function (p) { el.style.removeProperty(p); });
      el.style.setProperty('white-space', 'normal', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('text-overflow', 'clip', 'important');
    }
  }

  /* 1. Titres de toutes les pages */
  var TITRES = 'h1, .section-header__title, .page-title, .product-single__title, .collection-hero__title,' +
    ' .rte h2, .rte h3, .rte h4, .product-single__description h2, .product-single__description h3, .product-single__description h4';

  function titres() {
    document.querySelectorAll(TITRES).forEach(function (h) {
      if (h.closest('.drawer, .site-nav, .visually-hidden')) return;
      uneLigne(h, 11);
    });
  }

  /* 2. Accueil + bandeau de reassurance : tous les textes courts sur UNE ligne
        (titres, sous-titres, accroches, boutons). Les longs textes de presentation restent en paragraphe. */
  var COURTS = 'h1, h2, h3, h4, h5, p, .btn, a.btn, .section-header__title, .feature-row__subtitle,' +
    ' .subtitle, .footer__newsletter-form--text, .rte > div, .vgcard__t, .vgcard__p, .vgcard__b, [class*="title"], [class*="subtitle"]';
  var BLOCS = /^(P|DIV|H1|H2|H3|H4|H5|H6|UL|OL|LI|TABLE|SECTION|ARTICLE|FIGURE|FORM)$/;

  function feuille(el) {
    for (var i = 0; i < el.children.length; i++) {
      if (BLOCS.test(el.children[i].tagName) || el.children[i].querySelector('img, picture, svg, video')) return false;
    }
    return true;
  }

  function textesCourts() {
    var zones = [];
    if (document.body.classList.contains('template-index')) zones.push(document.getElementById('MainContent'));
    document.querySelectorAll('[id*="footer-promotions"], .footer-promotions, .footer__newsletter-form').forEach(function (z) { zones.push(z); });
    zones.forEach(function (z) {
      if (!z) return;
      z.querySelectorAll(COURTS).forEach(function (el) {
        if (el.closest('.drawer, .site-nav, .visually-hidden, .grid-product, .vog-hero-wrap, [class*="slideshow"], [class*="article"], [class*="blog"], [class*="loox"], [class*="marq"], .vgcard, .vog-bar, .footer__newsletter-form')) return;
        if (!feuille(el)) return;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t || t.length > 90) return;   /* au-dela, c'est un vrai paragraphe */
        uneLigne(el, 8);
      });
    });
  }

  /* 3. Blocs et lignes de tableau vides qui creent des trous */
  var ZONES = '.rte, .product-single__description, .collection-description, .feature-row__text';

  function videsOff() {
    document.querySelectorAll(ZONES).forEach(function (z) {
      z.querySelectorAll('p, div, h2, h3, h4, h5, tr').forEach(function (el) {
        if (el.querySelector('img, picture, iframe, video, svg, canvas, input, select, textarea, button, table, form, [style*="background"]')) return;
        var cls = (el.className || '') + ' ' + (el.id || '');
        if (/loox|alma|vgal|wishlist|chat|swatch|globo/i.test(cls)) return;
        if (getComputedStyle(el).backgroundImage !== 'none') return;
        var t = (el.textContent || '').replace(/[\s ​]+/g, '');
        if (t === '' && el.offsetHeight > 0) el.style.setProperty('display', 'none', 'important');
      });
    });
    /* fin de fiche produit : plus de marge sous le dernier element visible */
    document.querySelectorAll('.product-single__description, .product-single__meta').forEach(function (z) {
      var kids = [].slice.call(z.children).filter(function (k) { return k.offsetHeight > 0; });
      var last = kids[kids.length - 1];
      if (last) { last.style.setProperty('margin-bottom', '0', 'important'); last.style.setProperty('padding-bottom', '0', 'important'); }
    });
  }

  /* 4. Corrections d'espacement complementaires (blog, page Marques, articles) */
  function stylesEnPlus() {
    if (document.getElementById('vog-mobile-extra')) return;
    var st = document.createElement('style');
    st.id = 'vog-mobile-extra';
    st.textContent = '@media only screen and (max-width:768px){' +
      'html body .article-item{margin-bottom:20px!important}' +
      'html body .article__grid-meta{padding-bottom:0!important}' +
      'html body .collection-list--page .collection-list__item{margin-bottom:12px!important}' +
      'html body .collection-list--page .collection-item{margin-bottom:0!important}' +
      'html body .collection-list--page .grid{margin-bottom:0!important}' +
      'html body .article__body{margin-bottom:12px!important}' +
      'html body .article__body + *, html body .article__footer, html body .article__navigation{margin-top:0!important;padding-top:0!important}' +
      'html body .template-article .page-content, html body .page-content--article{padding-bottom:16px!important}' +
      /* textes courts : taille proportionnelle a la largeur de l'ecran (fonctionne aussi avec le zoom de Safari) */
      'html body .vog-bar--footer-promotions{grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important}' +
      'html body .vog-bar--footer-promotions .vog-bar__item{min-width:0!important}' +
      'html body .vog-bar--footer-promotions .vog-bar__item span{font-size:min(11px,2.85vw)!important;white-space:nowrap!important}' +
      'html body .vog-bar--footer-promotions svg,html body .vog-bar--footer-promotions img{width:min(18px,4.6vw)!important;height:min(18px,4.6vw)!important}' +
      'html body .vgcard{gap:min(12px,3vw)!important;padding:0 8px!important}' +
      'html body .vgcard__img,html body .vgcard__img img{flex:0 0 min(56px,14vw)!important;width:min(56px,14vw)!important;height:min(56px,14vw)!important;max-width:min(56px,14vw)!important}' +
      'html body .vgcard__txt{min-width:0!important;flex:1 1 auto!important}' +
      'html body .vgcard__t{font-size:min(15px,3.9vw)!important;white-space:nowrap!important}' +
      'html body .vgcard__p{font-size:min(12.5px,3.15vw)!important;white-space:nowrap!important;overflow:visible!important;text-overflow:clip!important}' +
      'html body .footer__newsletter-form--text{font-size:min(12px,2.6vw)!important;letter-spacing:.02em!important;white-space:nowrap!important;overflow:visible!important;text-overflow:clip!important}' +
      '}';
    document.head.appendChild(st);
  }

  function tout() {
    if (window.innerWidth > MOBILE) return;
    stylesEnPlus(); videsOff(); titres(); textesCourts();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  window.addEventListener('load', tout);
  window.addEventListener('resize', function () { if (window.innerWidth <= MOBILE) { titres(); textesCourts(); } });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(tout);
  setTimeout(tout, 1500);
  setTimeout(tout, 3500);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function () { setTimeout(tout, 100); });
  var attente = null;
  try {
    new MutationObserver(function () { clearTimeout(attente); attente = setTimeout(tout, 400); })
      .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
